(() => {

	    if (typeof __webpack_require__ === "undefined") {
	      return;
	    }
	    var oldGetScriptFilename = __webpack_require__.u;
	    var oldLoadScript = __webpack_require__.e;
	    var countMap = {};
	    __webpack_require__.u = function (chunkId) {
	      var realSrc = oldGetScriptFilename(chunkId);
	      var count = countMap[chunkId];
	      return count === undefined
	        ? realSrc
	        : realSrc + "?chunk-retry-count=" + count;
	    };
	    __webpack_require__.e = function (chunkId) {
	      return oldLoadScript(chunkId).catch(function (error) {
	        var count = countMap[chunkId];
	        var retries = count === undefined ? 5 : count;
	        if (retries < 1) {
	          var realSrc = oldGetScriptFilename(chunkId);
	          error.message = "Loading chunk " + chunkId + " failed after 5 retries.\n(" + realSrc + ")";
	          error.request = realSrc;
	          throw error;
	        }
	        return new Promise(function (resolve) {
	          var retryAttempt = 5 - retries + 1;
	          setTimeout(function () {
	            countMap[chunkId] = retries - 1;
	            resolve(__webpack_require__.e(chunkId));
	          }, retryAttempt * 1000);
	        });
	      });
	    };
})();